import { createSelector } from 'reselect'

import { paramSelector } from '../../../utils/selectors'
import { RootState } from '../../types'

type WithReportId = {
  reportId: string
}

export const selectState = createSelector(
  (s: RootState) => s.accountReports,
  b => b
)

export const areReportsLoading = createSelector(selectState, s => s.loading)

export const getAccountReports = createSelector(selectState, s => s.data)

export const getAccountReportsFilter = createSelector(selectState, s => s.filter)

export const isReportDetailLoading = createSelector(
  selectState,
  paramSelector<WithReportId>(),
  (s, { reportId }) => s.loadingEntities[reportId] || false
)

export const getReportDetail = createSelector(
  selectState,
  paramSelector<WithReportId>(),
  (s, { reportId }) => s.reportDetails[reportId]
)

export const getAccountReportFilters = createSelector(selectState, s => s.filters)

export const getDocument = createSelector(selectState, s => s.htmlDocument)
